import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  ViewEncapsulation,
  ViewRef,
} from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { TruncatePipe } from '../../../shared/truncate.pipe';
import { PopoverElementDirective } from '../popover/popover-element.directive';
import { PopoverTriggerDirective } from '../popover/popover-trigger.directive';
import { TooltipTextModule } from './tooltip-text.module';

@Component({
  selector: 'app-tooltip-text',
  templateUrl: './tooltip-text.component.html',
  styleUrls: ['./tooltip-text.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [PopoverTriggerDirective, PopoverElementDirective, TooltipTextModule, TruncatePipe],
})
export class TooltipTextComponent implements OnInit, AfterContentChecked {
  @Input() tooltipContent: string;
  @Input() content: string;
  @Input() placement?: 'top' | 'bottom' | 'right';
  @Input() promotionLocation: string;
  @Input() charactersLimit: number;
  @Input() closeOnRotate: boolean;

  isMobile = this.deviceDetectorService.isMobile();
  isTablet = this.deviceDetectorService.isTablet();
  isDesktop = this.deviceDetectorService.isDesktop();
  checkTooltip = true;

  @HostListener('window:orientationchange', ['$event'])
  onRotate(event: any) {
    setTimeout(() => {
      this.checkTooltipInElem();
      this.checkForTelNumber();
    }, 1000);
  }

  constructor(
    private deviceDetectorService: DeviceDetectorService,
    private elementRef: ElementRef<HTMLElement>,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.checkTooltipInElem();
    this.checkForTelNumber();
  }

  ngAfterContentChecked() {
    this.checkTooltipInElem();
    this.checkForTelNumber();
  }

  checkTooltipInElem() {
    setTimeout(() => {
      const element = this.elementRef.nativeElement.firstElementChild;
      this.checkTooltip = this.isTooltipEnabled(element);
      if (!(this.cdr as ViewRef).destroyed) {
        this.cdr.detectChanges();
      }
    });
  }

  isTooltipEnabled(element: any): boolean {
    if (element) {
      if (element.clientHeight > 24) {
        return element.scrollHeight <= element.clientHeight ? true : false;
      }
      if (element.scrollWidth > 0) {
        return element.scrollWidth <= element.clientWidth ? true : false;
      }
    }
  }

  checkForTelNumber(): void {
    setTimeout(() => {
      document.querySelectorAll('a[href^="tel:"]').forEach((link: Element) => {
        if (link instanceof HTMLAnchorElement) {
          const parent = link.parentElement;

          if (parent) {
            // Create a text node with the content of the link
            const textNode = document.createTextNode(link.innerText);

            // Replace the <a> element with the text node
            parent.replaceChild(textNode, link);

            // Normalize text nodes to ensure surrounding text is connected seamlessly
            parent.normalize();
          }
        }
      });
    }, 1000);
  }

  get isTruncated(): boolean {
    if (this.content) {
      return this.content.length > +this.charactersLimit;
    }
  }
}
